import * as React from 'react';

const ClipboardSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M18 3h-3V2H9v1H6.052L6 4H4v18h16V4h-2V3zm-1 2H7V4v.026h2l1.027.004L10.025 3H14v1h3v1zM7 19V8H6v12h12V8h-1v11H7zm-2 2V5h1v-.159V6h12V5h1v16H5zm4-9v1h6v-1H9zm0-3v1h6V9H9zm0 6v1h6v-1H9z"
            fillRule="evenodd"
        />
    </svg>
);

ClipboardSvg.displayName = 'ClipboardSvg';
export default ClipboardSvg;
